import i18n from "config/i18next";
import { NotificationStateType } from "reducers/types/notification";
import "i18n";
import { store } from "store";
import { actions } from "../reducers/session";
import { dirtyAlertParams } from "./types";

export const dirtyAlert = (params: dirtyAlertParams): NotificationStateType => {
  const { scroll = true, externalCancel = false, scrollTo } = params;
  const html = document.documentElement;
  const height = Math.max(html.clientHeight, html.scrollHeight);
  const handleCancel = () => {
    params.onCancel();
    !externalCancel && store.dispatch(actions.setDirty(false));
  };
  const scrollWindow = () => {
    window.scroll({
      top: height,
      left: 0,
      behavior: "smooth",
    });
  };
  const scrollMethod = scrollTo || scrollWindow;
  return {
    id: "notification-dirty",
    level: "warning",
    title: params.title || i18n.t("alerts:saveChangesTitle"),
    body: params.message || i18n.t("alerts:saveChangesMessage"),
    onConfirmLabel: params.confirmLabel || "global:goToSave",
    onCancelLabel: params.cancelLabel || "global:notSave",
    onCancel: handleCancel,
    onConfirm: scroll ? scrollMethod : undefined,
  };
};

export const serverErrorAlert = (onClose?: Function): NotificationStateType => {
  return {
    id: "notification-server-error",
    level: "error",
    title: i18n.t("alerts:serverErrorTitle"),
    body: i18n.t("alerts:serverErrorMessage"),
    onClose,
  };
};

export const connectionErrorAlert = (
  onClose?: Function
): NotificationStateType => {
  return {
    id: "notification-connection-error",
    level: "error",
    title: i18n.t("alerts:connectionErrorTitle"),
    body: i18n.t("alerts:connectionErrorMessage"),
    onClose,
  };
};
